import { Text } from "@medusajs/ui"
import { VariantPrice } from "types/global"

export default function PreviewPrice({
  price,
  discounted,
}: {
  price: VariantPrice
  /**
   * Precio con descuento (promociones automáticas de Medusa), calculado por
   * el padre. `null`/undefined = sin descuento.
   */
  discounted?: number | null
}) {
  if (!price) {
    return null
  }

  const hasPromo =
    typeof discounted === "number" &&
    discounted < price.calculated_price_number

  if (hasPromo) {
    const pct = Math.round(
      (1 - discounted! / price.calculated_price_number) * 100
    )
    return (
      <>
        <Text
          className="line-through text-ui-fg-muted text-[#f57aa9]"
          data-testid="original-price"
        >
          {price.calculated_price} (Iva incluido)
        </Text>
        <Text
          className="text-ui-fg-interactive text-[#f57aa9]"
          data-testid="price"
        >
          {discounted!.toFixed(2)}€ (-{pct}%)
        </Text>
      </>
    )
  }

  return (
    <Text
      className="text-ui-fg-muted text-[#f57aa9]"
      data-testid="price"
    >
      {price.calculated_price} (Iva incluido)
    </Text>
  )
}
